<template>
  <v-flex class="login-form">
    <div class="display-1 my-8 text-center">
      <img
        src="assets/img/logo-eduniversal.png"
        style="max-width: 258px"
        class="mx-auto"
      />
    </div>
    <v-card light="light" class="mt-10">
      <v-card-text>
        <div
          class="subheading text-center font-weight-bold display-3 mt-6 mb-10"
        >
          <template>Connexion</template>
        </div>
        <ValidationObserver v-slot="{ handleSubmit  }">
          <v-form class="px-8" v-on:submit.prevent="handleSubmit(login)">
            <ValidationProvider rules="required" name="Pseudo" v-slot="{ errors }">
              <v-text-field
                v-model="form.username"
                light
                outlined
                large
                rounded
                label="Pseudo"
                class="user-pass"
                :error-messages="errors[0]"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider rules="required" name="Mot de passe" v-slot="{ errors }">
              <v-text-field
                v-model="form.password"
                light
                outlined
                large
                rounded
                hide-details="auto"
                label="Mot de passe"
                type="password"
                class="user-pass"
                :error-messages="errors[0]"
              ></v-text-field>
            </ValidationProvider>
            <p class="text-center">
              <v-btn
                x-large
                rounded
                class="purple darken-4 display-2 px-12 mt-4 text-capitalize btn-login"
                type="submit"
                >Connexion</v-btn
              >
            </p>
          </v-form>
        </ValidationObserver>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "LoginForm",
  data() {
    return {
      form: {
        username: null,
        password: null
      },
    };
  },
  computed: {},
  methods: {
    async login() {
      await this.$store.dispatch("login", this.form);
      this.$router.push({
        name: "News"
      });
    }
  }
};
</script>
